<!-- ukey登录 -->
<template>
    <div class="ukey-login">
        <div v-if="!showUpdate">
        <div class="text-center icon-container">
            <p><i class="iconukey"></i></p>
            <div>请使用法人一证通登录</div>
            <p v-if="app.cert" class="tip small-font mt10">
                已检测到USBkey，<a
                    class="blue-text pointer"
                    href="https://www.sheca.com/resources/tools"
                    target="_blank"
                    ><u>下载协卡助手</u></a
                >
            </p>
            <p v-else class="blue-text small-font mt10">
                请确认是否插入USBkey以及运行协卡助手
                <br>若无协卡助手,点此<a
                    class="blue-text pointer"
                    href="https://www.sheca.com/resources/tools"
                    target="_blank"
                    ><u><b>下载</b></u></a
                >
            </p>
        </div>
        <el-form :model="form" @submit.native.prevent ref="loginRef">
            <el-form-item>
                <el-input
                    v-model="form.pin"
                    :type="visiblePassword ? 'text' : 'password'"
                    :disabled="!(app.cert || app.certOfSM2)"
                    @keydown.enter.native="doLogin"
                    @change="errorMessage = ''"
                    placeholder="请输入Ukey密码"
                >
                    <i
                        :slot="Utils.isIE() ? 'append' : 'suffix'"
                        class="class-button"
                        @click="visiblePassword = !visiblePassword"
                        :class="
                            visiblePassword ? 'iconvisible' : 'iconinvisible'
                        "
                    ></i>
                </el-input>
                <div class="text-right small-font mt10 download-file">
                        <a
                            class="red-text pointer ml10"
                            download="UKEY密码框不能输入汇总.pdf"
                            href="/assets/js/vender/ukey_login_fail.pdf"
                            >谷歌浏览器不能输入密码？
                        </a>
                </div>
                <transition-group name="el-zoom-in-top">
                    <div
                        key="1"
                        v-if="errorMessage"
                        class="el-form-item__error"
                    >
                        {{ errorMessage }}
                    </div>
                </transition-group>
            </el-form-item>
            <el-form-item>
                <el-button
                    class="login-bar"
                    :loading="loading"
                    type="primary"
                    @click="handleLogin"
                    >登 录</el-button
                >
            </el-form-item>
        </el-form>
    </div>
    <div v-else>
        <h3 class="mb10">单位信息不一致</h3>
        <p class="mb10">您使用的法人一证通UKey证书信息与印章平台中单位信息不一致，是否变更印章平台的单位信息？</p>
        <el-button type="primary" @click="doUpdate" class="update-btn">变更</el-button>
        <el-button class="default-btn" @click="cancelUpdate" >取消，变更UKey</el-button>
    </div>
    </div>
</template>

<script>
import qs from 'qs';

export default {
    data() {
        return {
            form: {
                pin: ""
            },
            loading: false,
            errorMessage: "",
            visiblePassword: false,
            showUpdate:false
        };
    },
    computed: {
    },
    inject: ["app"],
    mounted() {
        try {
            let key = "UKEY_PASSWORD";
            if (localStorage.getItem(key)) {
                localStorage.removeItem(key);
            }
        } catch (error) {
            console.log(error);
        }
    },
    methods: {
        /**
         * 校验pin码
         */
        async verifyPin() {
            decodeURIComponent(this.app.cert);
            if (!this.form.pin) {
                return this.app.cert
                    ? "请输入Ukey密码!"
                    : "请确认是否插入USBkey或先下载驱动";
            }

            try {
                let resp = await this.app.ukey.verifyUserPin(this.form.pin);
                if (resp.code !== 0) {
                    return '验证失败';
                }
            } catch (error) {
                return (error && error.message) || "登录失败，请重试";
            }
            return "";
        },

        /**
         * 处理登录
         */
        async handleLogin() {
            this.errorMessage = await this.verifyPin();
            await this.doLogin();
        },

        getRandomA() {
            let random = "";
            Array(16)
                .fill(0)
                .map(() => {
                    random += Math.floor(Math.random() * 10);
                });
            return random;
        },
        async getLoginData(apiName,certType,cert) {
            try {
                const pin = this.form.pin;
                const randomA = this.getRandomA(16);
                let resp = await this.axios({
                    url: '/login/randomB',
                    method: 'Get',
                    params: { randomA },
                });
                const { randomB } = resp.data;
                const data = (
                    await this.app.ukey[apiName](
                        `${randomA}-${randomB}`,
                        pin
                    )
                );
                return {
                    key: randomB,
                    sign: data.result,
                    cert,
                    certType,
                };
            } catch (e) {
                console.log(e);
            }
        },

        loginConfirm(data){
            this.$alert(data, '', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '我知道了',
            });
        },

        /**
         * 登录
         */
        async doLogin() {
            try {
                this.loading = true;
                if (!this.errorMessage) {
                    let resp,loginData;
                    if(this.app.certOfSM2) {
                        loginData = await this.getLoginData('signBySm2','SM2',this.app.certOfSM2);
                    }else {
                        loginData = await this.getLoginData('signByRsa','RSA',this.app.cert);
                    }
                    const { sign } = loginData;
                    if(!sign) {
                        this.errorMessage = "验证失败";
                        return;
                    }
                    resp = await this.axios({
                        url: '/login',
                        method: 'POST',
                        data: qs.stringify(loginData),
                    });
                    resp = resp.data;
                    if (resp.code === 0) {
                        await this.$store.dispatch('initSystemConfig');
                        await this.$store.dispatch("initQuser");
                        this.$router.replace("/home");

                        if (this.Utils.isIE()) {
                            // IE浏览器将密码储存
                            this.$nextTick(() => {
                                let key = "UKEY_PASSWORD";
                                localStorage.setItem(key, this.form.pin);
                            });
                        }
                    } else if(resp.code === 112) {
                        this.cancelUpdate()
                    }else {
                        this.loginConfirm(resp.message)
                    }
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style lang="less" scoped>
.ukey-login {
    i.iconukey {
        font-size: 60px;
        color: @grey;
    }

    .icon-container {
        margin-bottom: 30px;
    }
    .class-button {
        cursor: pointer;
    }
    .update-btn , .default-btn {
       padding:8px;
    }
    .download-file {
        margin: 0 0 -22px;
    }

    .login-bar {
        width: 100%;
    }
}

</style>
